export const ROUTES = {
  LOGIN_REDIRECT: '/login-redirect',
  LOGIN_RENEW: '/login-renew',
  LOGIN_INIT: '/login-init',
  LOGOUT: '/log-out',
  LOGIN_ERROR: '/login-error',
  LOGOUT_REDIRECT: '/logout-redirect',
  ACCOUNT_ACTIVATION: '/account-activation',
  ERROR_401: '/401',
  SIGN_IN: '/signup',
  COUNTRY_SELECTOR: '/select-country',
  COUNTRY_SELECTOR_WITH_ISO_CODE: '/select-country/:countryISOUrl',
  COUNTRY_SELECTOR_WITH_SCHOOL: '/start-with-school/:preparationCentreId',
  EXAMS: '/exams',
  BASKET: '/basket',
  TEST_TAKER_DETAILS: '/test-taker-details',
  CANDIDATE_PRODUCT_DETAILS: '/candidate-product-details',
  MY_PROFILE: '/my-profile',
  MY_REGISTRATIONS: '/myRegistrations',
  MY_REGISTRATIONS_PAYMENTS: '/myRegistrations/payments',
  MY_REGISTRATIONS_SUMMARY: '/myRegistrations/summary',
  CHANGE_PASSWORD: '/change-password',
  INBOX: '/inbox',
  POST_RESULTS_SERVICES: '/postResultsServices',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  SELECT_PAYMENT: '/payment/:referenceNumber',
  PAYMENT_OFFLINE_SUMMARY: '/payment/offlineSummary/:referenceNumber',
  PAYMENT_ONLINE_SUMMARY: '/payment/onlineSummary/:referenceNumber',
  ERROR_404: '/404',
  CREATE_POST_RESULTS_SERVICE: '/postResultsServices/create',
  SELECT_PAYMENT_METHOD_POST_RESULTS_SERVICES: '/postResultsServices/paymentMethod/:paramsBase64String'
};
